<div class="dynamic-field form-select" [formGroup]="group">
  <mat-form-field appearance="outline" class="select">
    <mat-label>{{ config.label }}</mat-label>
    <mat-select *ngIf="useCompare" [compareWith]="compareFn"
      [formControlName]="config.name"
      (selectionChange)="onChange($event)" [multiple]="isMultipleSelect"
      [disabled]="!!config.disabled">
      <mat-option *ngFor="let option of config.options" [value]="option">
        <span *ngIf="config.displayValue">{{ config.displayValue(option) }}</span>
        <span *ngIf="!config.displayValue && config.display">{{ option[config.display] }}</span>
        <span *ngIf="!config.displayValue && !config.display">{{ option }}</span>
      </mat-option>
    </mat-select>
    <mat-select *ngIf="!useCompare" [multiple]="isMultipleSelect"
      [formControlName]="config.name"
      (selectionChange)="onChange($event)" [disabled]="!!config.disabled">
      <mat-option *ngFor="let option of config.options" [value]="option">
        <span *ngIf="config.displayValue">{{ config.displayValue(option) }}</span>
        <span *ngIf="!config.displayValue && config.display">{{ option[config.display] }}</span>
        <span *ngIf="!config.displayValue && !config.display">{{ option }}</span>
      </mat-option>
    </mat-select>
    <mat-error
      *ngIf="group.get(config.name)?.touched && group.get(config.name)?.hasError('required')">
      <span>Campo Obrigatório</span>
    </mat-error>
  </mat-form-field>
</div>
